import React from "react";
import { IconProps } from "../type";

export function ChevronDoubleDown({
  color = "currentColor",
  size = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.58985 12.4053L14.5899 20.6553C14.9646 20.9347 15.4715 21.0915 15.9999 21.0915C16.5282 21.0915 17.0351 20.9347 17.4099 20.6553L28.4099 12.4053C28.7553 12.1204 28.9414 11.7468 28.9297 11.3619C28.9179 10.9769 28.7093 10.6101 28.3469 10.3374C27.9845 10.0646 27.4961 9.90681 26.9829 9.89666C26.4697 9.8865 25.9709 10.0248 25.5899 10.2828L15.9999 17.4753L6.40985 10.2828C6.22758 10.1325 6.00648 10.0115 5.75997 9.92719C5.51346 9.84288 5.24669 9.79702 4.97583 9.79238C4.70498 9.78774 4.43569 9.82443 4.18431 9.90021C3.93293 9.97598 3.7047 10.0893 3.51346 10.2332C3.32223 10.3771 3.17198 10.5487 3.07183 10.7375C2.97168 10.9263 2.92373 11.1284 2.93087 11.3315C2.93801 11.5347 3.00011 11.7346 3.11339 11.9192C3.22667 12.1037 3.38877 12.2691 3.58985 12.4053Z"
        fill={color}
      />
      <path
        d="M14.5897 13.7177C14.9644 13.9971 15.4713 14.1539 15.9997 14.1539C16.528 14.1539 17.0349 13.9971 17.4097 13.7177L28.4097 5.46767C28.7551 5.1828 28.9412 4.80921 28.9295 4.42425C28.9177 4.0393 28.7091 3.67247 28.3467 3.39972C27.9843 3.12696 27.4959 2.96917 26.9827 2.95902C26.4695 2.94887 25.9707 3.08713 25.5897 3.34517L15.9997 10.5377L6.40966 3.34517C6.0286 3.08713 5.52983 2.94887 5.0166 2.95902C4.50338 2.96917 4.01501 3.12696 3.65262 3.39972C3.29023 3.67247 3.08158 4.0393 3.06986 4.42425C3.05814 4.80921 3.24425 5.1828 3.58966 5.46767L14.5897 13.7177Z"
        fill={color}
      />
    </svg>
  );
}
